var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-cont"},[_c('div',{staticClass:"loader-cont__wrapper"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('div',{staticClass:"loader_text"},[_vm._v(_vm._s(_vm.getTranslations.home_please_wait_page))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c468ec8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/game/PleaseWaitInit.vue
// module id = null
// module chunks = 